import { Pipe, PipeTransform } from '@angular/core';

/**
 * The admission path stores the literal string "N/A" for optional values that were never
 * filled in (the Applicants entity defaults several columns to it and the portal
 * registration writes it explicitly), so "N/A" is real data in the database rather than a
 * display fallback. Anything that reads as "no value" — null, undefined, blank/whitespace
 * or "N/A" in any casing — should print as an empty cell.
 */
export function isBlankValue(value: unknown): boolean {
  if (value === null || value === undefined) {
    return true;
  }
  const text = String(value).trim();
  return text === '' || text.toUpperCase() === 'N/A';
}

@Pipe({ name: 'blankIfNa' })
export class BlankIfNaPipe implements PipeTransform {
  transform(value: unknown): string {
    return isBlankValue(value) ? '' : String(value);
  }
}
